<div class="evc-page">

  <!-- ══════════════════════════════════════════════════════════════
       HERO — CHARGER BANNER
  ══════════════════════════════════════════════════════════════ -->
  <div class="evc-hero" [class.hero-charging]="isCharging" [class.hero-cut]="!isCharging">

    <!-- Animated energy particles (charging only) -->
    <div class="hero-particles" *ngIf="isCharging">
      <span class="particle p1"></span>
      <span class="particle p2"></span>
      <span class="particle p3"></span>
      <span class="particle p4"></span>
      <span class="particle p5"></span>
    </div>

    <!-- Left: charger identity -->
    <div class="hero-left">
      <div class="hero-breadcrumb">
        <span class="hb-site">{{ charger?.siteName ?? '…' }}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <polyline points="9 18 15 12 9 6" />
        </svg>
        <span class="hb-parent">Parent Unit: {{ charger?.parentLocationNo ?? '—' }}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <polyline points="9 18 15 12 9 6" />
        </svg>
        <span class="hb-loc">Unit: {{ charger?.unitNo ?? '—' }}</span>
      </div>

      <h1 class="hero-title">
        {{ charger?.evName ?? 'EV Charger' }}&nbsp;
      </h1>

      <div class="hero-meta">
        <span class="hero-meta-item" title="Meter Serial No">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="4" y="4" width="16" height="16" rx="2" />
            <line x1="9" y1="9" x2="15" y2="9" />
            <line x1="9" y1="13" x2="15" y2="13" />
          </svg>
          MTR: {{ serialNo || charger?.meterSerialNo || '—' }}
        </span>
        <span class="hero-sep" *ngIf="charger?.dicName">·</span>
        <span class="hero-meta-item" title="Gateway Name" *ngIf="charger?.dicName">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
          </svg>
          CB Name: {{ charger?.dicName }}
        </span>
        <span class="hero-sep">·</span>
        <span class="hero-meta-item" title="Gateway ID (Data Logger)">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12.55a11 11 0 0 1 14.08 0" />
            <path d="M1.42 9a16 16 0 0 1 21.16 0" />
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
            <circle cx="12" cy="20" r="1" />
          </svg>
          GW: {{ charger?.dataLoggerId || charger?.gatewaySerialNo || '—' }}
        </span>
        <span class="hero-sep" *ngIf="mobileNo || charger?.mobileNo">·</span>
        <span class="hero-meta-item" title="Contact No" *ngIf="mobileNo || charger?.mobileNo">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path
              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
          {{ mobileNo || charger?.mobileNo }}
        </span>
        <span class="hero-sep" *ngIf="emailId">·</span>
        <span class="hero-meta-item" title="Email ID" *ngIf="emailId">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
          {{ emailId }}
        </span>
      </div>

      <!-- State & Alert Pills -->
      <div class="hero-pills-row">
        <div class="hero-state-pill" [class.pill-charging]="isCharging" [class.pill-cut]="!isCharging">
          <span class="pill-dot" [class.dot-charging]="isCharging" [class.dot-cut]="!isCharging"></span>
          {{ isCharging ? 'Connected' : 'Disconnected' }}
        </div>

        <div class="hero-alert-pill">
          <span class="alert-icon">⚡</span>
          {{ charger?.paymentType ?? 'Postpaid' }}
        </div>

        <div class="hero-alert-pill alert-warn"
          *ngIf="(charger?.balanceAmount ?? 0) < (charger?.lowBalanceThreshold ?? 200)">
          <span class="alert-icon">₹</span>
          Low Balance Alert
        </div>
      </div>
    </div>

    <!-- Centre: Modern Charger Graphic -->
    <div class="hero-center">
      <div class="mcg-wrapper" [class.is-charging]="isCharging">
        <div class="mcg-ring">
          <svg viewBox="0 0 120 120" class="mcg-ring-svg">
            <!-- Background ring -->
            <circle cx="60" cy="60" r="54" class="mcg-ring-bg"></circle>
            <!-- Progress ring (animated when charging) -->
            <circle cx="60" cy="60" r="54" class="mcg-ring-progress" *ngIf="isCharging"></circle>
          </svg>
        </div>
        <!-- Center icon -->
        <div class="mcg-center-icon">
          <svg *ngIf="isCharging" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
          </svg>
          <svg *ngIf="!isCharging" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="12.41 6.75 13 2 10.57 4.92"></polyline>
            <polyline points="18.57 12.91 21 10 15.66 10"></polyline>
            <polyline points="8 8 3 14 12 14 11 22 16 16"></polyline>
            <line x1="2" y1="2" x2="22" y2="22"></line>
          </svg>
        </div>
        <!-- Outer glow effect -->
        <div class="mcg-glow" *ngIf="isCharging"></div>
      </div>
      <!-- Status label -->
      <div class="mcg-status-label" [class.active]="isCharging">
        {{ isCharging ? 'CONNECTED' : 'DISCONNECTED' }}
      </div>
    </div>

    <!-- Right: duration + balance -->
    <div class="hero-right">
      <div class="hero-kpi" *ngIf="isCharging">
        <div class="hkpi-label">Connected for</div>
        <div class="hkpi-value hkpi-duration">{{ durationLabel }}</div>
        <div class="hkpi-sub">since {{ charger?.lastPowerCutTime | slice:0:16 }}</div>
      </div>
      <div class="hero-kpi" *ngIf="!isCharging">
        <div class="hkpi-label">Status</div>
        <div class="hkpi-value hkpi-cut">Disconnected</div>
        <div class="hkpi-sub">{{ charger?.lastPowerCutTime | slice:0:16 }}</div>
      </div>

      <div class="hero-divider"></div>

      <div class="hero-kpi">
        <div class="hkpi-label">EV Balance</div>
        <div class="hkpi-value" [ngClass]="getBalanceClass(charger?.balanceAmount ?? 0)">
          ₹{{ charger?.balanceAmount?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ??
          '—' }}
        </div>
      </div>

      <!-- Shimmer while loading -->
      <div class="hero-shimmer" *ngIf="chargerLoading">
        <div class="shimmer-line shimmer-anim"></div>
        <div class="shimmer-line short shimmer-anim"></div>
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════
       RYB DONUT & CIRCULAR TELEMETRY DASHBOARD
  ══════════════════════════════════════════════════════════════ -->
  <div class="evc-telemetry-panel">

    <!-- 1. RYB 3-Phase Donut Chart Overview Card -->
    <div class="telemetry-card ryb-donut-card">
      <div class="tc-header">
        <div class="tc-title-group">
          <span class="tc-title">3-PHASE CURRENT (RYB)</span>
          <span class="tc-subtitle">Phase Balance & Distribution</span>
        </div>
        <span class="balance-badge" [ngClass]="phaseBalanceStatus.class">
          {{ phaseBalanceStatus.label }}
        </span>
      </div>

      <div class="donut-chart-container">
        <!-- SVG Donut Chart -->
        <div class="donut-svg-wrapper">
          <svg viewBox="0 0 120 120" class="ryb-donut-svg">
            <!-- Background base track -->
            <circle cx="60" cy="60" r="50" class="donut-track" />

            <!-- Red Phase Arc -->
            <circle cx="60" cy="60" r="50" class="donut-arc arc-r" [style.strokeDasharray]="rArcDash"
              [style.strokeDashoffset]="rArcOffset" />

            <!-- Yellow Phase Arc -->
            <circle cx="60" cy="60" r="50" class="donut-arc arc-y" [style.strokeDasharray]="yArcDash"
              [style.strokeDashoffset]="yArcOffset" />

            <!-- Blue Phase Arc -->
            <circle cx="60" cy="60" r="50" class="donut-arc arc-b" [style.strokeDasharray]="bArcDash"
              [style.strokeDashoffset]="bArcOffset" />
          </svg>

          <!-- Donut center readout -->
          <div class="donut-center-info">
            <span class="dc-total-val">{{ totalCurrent }}</span>
            <span class="dc-unit">TOTAL AMPS</span>
          </div>
        </div>

        <!-- RYB Quick Breakdown Legend -->
        <div class="donut-legend-breakdown">
          <div class="leg-item leg-r">
            <div class="leg-top">
              <span class="leg-dot dot-r"></span>
              <span class="leg-phase">R-Current</span>
              <span class="leg-pct">{{ totalCurrent > 0 ? (Math.round((currentR / totalCurrent) * 100)) : 0 }}%</span>
            </div>
            <div class="leg-val">{{ currentR }} <small>A</small></div>
          </div>

          <div class="leg-item leg-y">
            <div class="leg-top">
              <span class="leg-dot dot-y"></span>
              <span class="leg-phase">Y-Current</span>
              <span class="leg-pct">{{ totalCurrent > 0 ? (Math.round((currentY / totalCurrent) * 100)) : 0 }}%</span>
            </div>
            <div class="leg-val">{{ currentY }} <small>A</small></div>
          </div>

          <div class="leg-item leg-b">
            <div class="leg-top">
              <span class="leg-dot dot-b"></span>
              <span class="leg-phase">B-Current</span>
              <span class="leg-pct">{{ totalCurrent > 0 ? (Math.round((currentB / totalCurrent) * 100)) : 0 }}%</span>
            </div>
            <div class="leg-val">{{ currentB }} <small>A</small></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. Phase-R Circle Radial Gauge Card -->
    <div class="telemetry-card phase-gauge-card phase-r">
      <div class="tc-header">
        <span class="phase-tag tag-r">R-PHASE</span>
        <span class="voltage-chip">{{ charger?.voltageR ?? 0 }} V</span>
      </div>

      <!-- Centered Radial Dial Hero -->
      <div class="gauge-hero-container">
        <div class="circle-dial-wrapper">
          <svg viewBox="0 0 100 100" class="circle-dial-svg">
            <circle cx="50" cy="50" r="38" class="dial-track" />
            <circle cx="50" cy="50" r="38" class="dial-arc arc-r" [style.strokeDasharray]="rDialDash" />
          </svg>
          <div class="dial-center">
            <span class="dial-val">{{ currentR }}</span>
            <span class="dial-unit">A</span>
          </div>
        </div>
      </div>

      <!-- Bottom Metrics Split Tiles -->
      <div class="phase-footer-grid">
        <div class="pf-tile">
          <span class="pft-label">Voltage</span>
          <span class="pft-value">{{ charger?.voltageR ?? '—' }} <small>V</small></span>
        </div>
        <div class="pf-tile">
          <span class="pft-label">Share</span>
          <span class="pft-value pft-share-r">{{ totalCurrent > 0 ? (Math.round((currentR / totalCurrent) * 100)) : 0
            }}<small>%</small></span>
        </div>
      </div>
    </div>

    <!-- 3. Phase-Y Circle Radial Gauge Card -->
    <div class="telemetry-card phase-gauge-card phase-y">
      <div class="tc-header">
        <span class="phase-tag tag-y">Y-PHASE</span>
        <span class="voltage-chip">{{ charger?.voltageY ?? 0 }} V</span>
      </div>

      <!-- Centered Radial Dial Hero -->
      <div class="gauge-hero-container">
        <div class="circle-dial-wrapper">
          <svg viewBox="0 0 100 100" class="circle-dial-svg">
            <circle cx="50" cy="50" r="38" class="dial-track" />
            <circle cx="50" cy="50" r="38" class="dial-arc arc-y" [style.strokeDasharray]="yDialDash" />
          </svg>
          <div class="dial-center">
            <span class="dial-val">{{ currentY }}</span>
            <span class="dial-unit">A</span>
          </div>
        </div>
      </div>

      <!-- Bottom Metrics Split Tiles -->
      <div class="phase-footer-grid">
        <div class="pf-tile">
          <span class="pft-label">Voltage</span>
          <span class="pft-value">{{ charger?.voltageY ?? '—' }} <small>V</small></span>
        </div>
        <div class="pf-tile">
          <span class="pft-label">Share</span>
          <span class="pft-value pft-share-y">{{ totalCurrent > 0 ? (Math.round((currentY / totalCurrent) * 100)) : 0
            }}<small>%</small></span>
        </div>
      </div>
    </div>

    <!-- 4. Phase-B Circle Radial Gauge Card -->
    <div class="telemetry-card phase-gauge-card phase-b">
      <div class="tc-header">
        <span class="phase-tag tag-b">B-PHASE</span>
        <span class="voltage-chip">{{ charger?.voltageB ?? 0 }} V</span>
      </div>

      <!-- Centered Radial Dial Hero -->
      <div class="gauge-hero-container">
        <div class="circle-dial-wrapper">
          <svg viewBox="0 0 100 100" class="circle-dial-svg">
            <circle cx="50" cy="50" r="38" class="dial-track" />
            <circle cx="50" cy="50" r="38" class="dial-arc arc-b" [style.strokeDasharray]="bDialDash" />
          </svg>
          <div class="dial-center">
            <span class="dial-val">{{ currentB }}</span>
            <span class="dial-unit">A</span>
          </div>
        </div>
      </div>

      <!-- Bottom Metrics Split Tiles -->
      <div class="phase-footer-grid">
        <div class="pf-tile">
          <span class="pft-label">Voltage</span>
          <span class="pft-value">{{ charger?.voltageB ?? '—' }} <small>V</small></span>
        </div>
        <div class="pf-tile">
          <span class="pft-label">Share</span>
          <span class="pft-value pft-share-b">{{ totalCurrent > 0 ? (Math.round((currentB / totalCurrent) * 100)) : 0
            }}<small>%</small></span>
        </div>
      </div>
    </div>

    <!-- 5. Power & Load Summary Card -->
    <div class="telemetry-card load-card">
      <div class="tc-header">
        <div class="tc-title-group">
          <span class="tc-title">POWER & LOAD</span>
          <span class="tc-subtitle">Real-time Telemetry</span>
        </div>
        <div class="live-pill">
          <span class="live-dot"></span>
          LIVE
        </div>
      </div>

      <div class="load-tiles-grid">
        <div class="lt-tile lt-primary">
          <span class="lt-label">Instant Load</span>
          <span class="lt-value lt-emerald">{{ charger?.instantLoadKw ?? '0.00' }} <small>kW</small></span>
        </div>
        <div class="lt-tile">
          <span class="lt-label">Apparent Load</span>
          <span class="lt-value">{{ charger?.instantLoadKva ?? '0.00' }} <small>kVA</small></span>
        </div>
        <div class="lt-tile lt-full-row">
          <span class="lt-label">Power Factor</span>
          <span class="lt-value lt-amber">{{ (charger?.powerFactor | number:'1.2-2') ?? '0.00' }}
            <small>PF</small></span>
        </div>
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════
       4 DATA SECTIONS (Mini Components with Table & Chart View)
  ══════════════════════════════════════════════════════════════ -->
  <div class="evc-tables">
    <!-- 1. EV Recharge History -->
    <app-evc-recharge-history [locationId]="evLocationId" [siteId]="siteId" [evName]="charger?.evName"></app-evc-recharge-history>

    <!-- 2. EV Charging History -->
    <app-evc-charging-history [locationId]="evLocationId" [siteId]="siteId"
      [sensorId]="sensorId" [evName]="charger?.evName"></app-evc-charging-history>

    <!-- 3. EV Daily Consumption Report -->
    <app-evc-daily-consumption [locationId]="evLocationId" [siteId]="siteId" [evName]="charger?.evName"></app-evc-daily-consumption>

    <!-- 4. EV Monthly Consumption Report -->
    <app-evc-monthly-consumption [locationId]="evLocationId" [siteId]="siteId" [evName]="charger?.evName"></app-evc-monthly-consumption>
  </div>
</div>